import { assetworksData } from "game-layers";
import { ThemeSetup } from "setup/theme-setup";
import { SlotWorks } from "slotworks/slotworks";

SlotWorks.go(new ThemeSetup({ gameId: 78, ways: true }), assetworksData);
